import axios from 'axios';

export default () => {
    return axios.create({
        baseURL: ''
    });
};


// WEBPACK FOOTER //
// ./src/services/StreamsAPI.js